import React from 'react';
import { CustomSelectButton, TextBold } from './AddUserComponents';
import { I18n } from 'react-redux-i18n-lite';
import ParticipantCard from './ParticipantCard';
import CustomSelect from '../../../common/customSelect/CustomSelect';
import CustomIcon from '../../../common/CustomIcon';
import PropTypes from 'prop-types';
import { PARTICIPANTS_ROLE_SELECTION as OPTIONS, ROLE } from '../../../../const';

class RoleView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectValues: [],
      open: false,
      selectedRole: this.props.selectedRole
    };
  }

  componentDidMount() {
    const options = OPTIONS.map(option => ({
      ...option,
      name: I18n.t(option.name)
    }));

    this.setState({
      selectValues: options
    });
  }

  handleClickMenuItem = option => {
    this.setState({ selectedRole: option });
    this.props.events.onChange(option);
  };

  toggleOpenMenu = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  closeMenu = () => {
    this.setState({ open: false });
  };

  render() {
    const { user, selectedClassroomName } = this.props;
    const { open, selectValues, selectedRole } = this.state;
    const { root, textBold, participantCard, selectButton, select } = this.props.className;

    return (
      <div className={root}>
        <TextBold className={textBold}>{`${I18n.t(
          'participants.drawer.teachers.titleB'
        )} ${selectedClassroomName}:`}</TextBold>
        <ParticipantCard className={participantCard} user={user} isMenuB={true} />
        <CustomSelectButton
          className={`dropdown-header ${selectButton}`}
          innerRef={node => (this.buttonRef = node)}
          onClick={this.toggleOpenMenu}
        >
          {selectedRole.name}
          <CustomIcon name="triangle-arrow-icon" size={16} />
        </CustomSelectButton>
        <CustomSelect
          open={open}
          showCheckedIcon={true}
          buttonRef={this.buttonRef}
          options={selectValues}
          handleCloseSelect={this.closeMenu}
          handleClickMenuItem={this.handleClickMenuItem}
          selectedItem={selectedRole}
          className={select}
        />
      </div>
    );
  }
}

RoleView.propTypes = {
  user: PropTypes.object,
  selectedRole: PropTypes.object,
  selectedClassroomName: PropTypes.string,
  events: PropTypes.shape({
    onChange: PropTypes.func
  }),
  className: PropTypes.shape({
    root: PropTypes.string,
    textBold: PropTypes.string,
    participantCard: PropTypes.string,
    selectButton: PropTypes.string,
    select: PropTypes.string
  })
};

RoleView.defaultProps = {
  user: {},
  selectedRole: {
    name: 'Instructor',
    value: ROLE.INSTRUCTOR
  },
  selectedClassroomName: '',
  events: {
    onChange: e => console.log('Event onChange', e)
  },
  className: {
    root: '',
    textBold: '',
    participantCard: '',
    selectButton: '',
    select: ''
  }
};

export default RoleView;
